/**
 * Role Badge Component
 * ====================
 * Display badge for user roles
 */

import React from 'react';
import { ROLE_LABELS } from '../../utils/constants';

const RoleBadge = ({ role, isPrimary = false, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const roleColors = {
    admin: 'bg-primary-100 text-primary-800 border-primary-200',
    bd_team: 'bg-blue-100 text-blue-800 border-blue-200',
    compliance_officer: 'bg-orange-100 text-orange-800 border-orange-200',
    viewer: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  const baseClasses = 'inline-flex items-center gap-1.5 font-medium rounded-full border';
  const colorClasses = roleColors[role] || roleColors.viewer;

  return (
    <span className={`${baseClasses} ${sizeClasses[size]} ${colorClasses} ${className}`}>
      {ROLE_LABELS[role] || role}
      {isPrimary && (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      )}
    </span>
  );
};

export default RoleBadge;

